import { useNavigate } from "react-router-dom";
import { Box, Typography, Container, Grid } from "@mui/material";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { ToolSelectCard } from "../ToolSelectCard";
import { SPACING } from "../../../utils/constants/designConstants";

const TOOLS = [
  {
    id: "supply-constants",
    title: "Supply Constants",
    description: "Upload your file and generate supply-side constants.",
    icon: Inventory2Icon,
    route: "/AiToolkit/Supply_Constants",
    accentColor: "#B9FF66",
  },
  {
    id: "demand-constants",
    title: "Demand Constants",
    description: "Upload your file and generate demand-side constants.",
    icon: ShowChartIcon,
    route: "/AiToolkit/Demand_Constants",
    accentColor: "#8F7EF8",
  },
];

export function SupplierDemandConstantsForm() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: "100vh" }}>
      <Container maxWidth="lg">
        <Box sx={{ pt: SPACING.SECTION_TOP, mb: SPACING.SECTION_GAP }}>
          <Typography variant="subtitle1" sx={{ py: 1.5, color: "primary.white" }}>
            Choose A Tool
          </Typography>
          <Typography variant="subtitle3" sx={{ fontWeight: 300, color: "gray.medium" }}>
            Select whether you want to generate supply or demand constants
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {TOOLS.map((tool) => (
            <Grid size={{ xs: 12, sm: 12, md: 6 }} key={tool.id}>
              <ToolSelectCard {...tool} onSelect={() => navigate(tool.route)} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
